export default __webpack_public_path__ + "static/media/logoImage.978a0c56.svg";